import { mergeTranslations } from './mergeTranslations';
import { resolveInitialLanguage, readStoredLanguage } from './languageSelection';

// Merges the student's language into the items before the runner starts. The
// overlay comes from get_questions; check_student never has one.
export const localizeTestItems = ({ testItems, overlay, storage }) => {
  const { availableLanguages, translations } = overlay ?? {};
  const language = resolveInitialLanguage({
    availableLanguages,
    stored: readStoredLanguage(storage),
  });

  return {
    testItems: mergeTranslations(testItems, translations, language),
    availableLanguages,
    language,
  };
};
